export default "__VITE_ASSET__BvzlDguC__"